import styled from "@emotion/styled";

export const Container = styled.div({
    marginLeft: -15,
    height: 33,
    width: "auto",
    display: "inline-block",
});

export const ButtonText = styled.div({
    display: "flex",
    width: `calc(100% - 30px)`,
});

export const Root = styled.span<{ last: boolean; collapsed: boolean }>(props => ({
    marginLeft: props.last ? (props.collapsed ? -60 : -20) : undefined,
}));

export const CollapsedSpan = styled.span({
    position: "relative",
    right: 11,
    top: 0,
});

export const CaretLeftFull = styled.span({
    position: "absolute",
    left: -9,
    top: 2,
});

export const CaretRightFull = styled.span({
    position: "absolute",
    right: -9,
    top: 2,
});
